module.exports = __webpack_public_path__ + "static/media/Banner_cloud.bdbb3191.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/Cloud/Banner_cloud.png
// module id = 52
// module chunks = 0